import addElementModalTemplate from '../../../../views/seats/add-element-modal.tpl.html';

class MoveToOtherListMainController {
    constructor($injector, rsvp, $scope, $uibModalInstance) {
        this.injector = $injector;
        this.scope = $scope;
        this.modalInstance = $uibModalInstance;
        this.givenRsvp = rsvp;
        this.api = this.injector.get('$http');
        this.growl = this.injector.get('growl');
        this.filter = this.injector.get('$filter');
        this.modal = this.injector.get('$uibModal');
        this.userStore = this.injector.get('Users');
        this.allowElementMultiSelection = _.get(this.userStore, 'state.company.settings.seatplans.enable_multiple_bookings_per_element')

        this.rsvp = null;
        this.contact = null;

        this.currentGuestlist = null;
        this.currentSeatplanElements = {};

        this.newGuestlist = null;
        this.newListAvailableElements = [];
        this.newListBlockedElements = [];
        this.newSeatplanElements = {};
        this.newListDataLoading = true;

        this.loading = true;
        this.newListId = null;

        this._loadRequiredData().then(() => {
            this._prepareDepositData().then(() => {
                this.loading = false;
            });
        });

        this._initWatchers();
    }

    _loadRequiredData() {
        return this.api.get(`rsvps/${this.givenRsvp.id}?include=guestlist,contact`).then((response) => {
            this.rsvp = _.cloneDeep(response.data.data);
            this.contact = this.rsvp.contact.data;
            this.currentGuestlist = this.rsvp.guestlist.data;
            this._prepareCurrentSeatplanElements();
            delete this.rsvp.contact;
            delete this.rsvp.guestlist;
            delete this.rsvp.changelog;
        }, () => {
            this.growl.error('Error while fetching data', {'title': 'Error'});
            this.dismissModal();
        });
    }

    _prepareCurrentSeatplanElements() {
        this.currentSeatplanElements = {};

        _.each(this.rsvp.seatplan_elements, (rse) => {
            this.currentSeatplanElements[rse.id] = rse;
        });
    }

    _prepareDepositData() {
        return new Promise((resolve) => {
            this.loading = true;

            this.newListId = null;
            const guestlistStore = this.injector.get('Guestlists').reset({
                listview: 'MoveToOtherListGuestlistsStore',
                persist: false
            });
            guestlistStore.commit('setFilter', {
                key: 'id',
                value: '!= ' + this.currentGuestlist.id
            });
            guestlistStore.commit('setSort', {
                'date': 'asc'
            });
            this.guestlistsSelectConfig = {
                store: guestlistStore,
                displayField: 'name',
                valueField: 'id',
                sortField: [
                    {
                        field: 'id',
                        direction: 'asc'
                    },
                    {
                        field: '$score'
                    }
                ]
            };
            resolve();

            this.loading = false;
        });
    }

    closeModal(resultData) {
        this.modalInstance.close(resultData);
    }

    dismissModal() {
        this.modalInstance.dismiss();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.newListId;
        }, () => {
            if (this.newListId) {
                this._prepareNewListInformation();
            }
        })
    }

    _prepareNewListInformation() {
        this.newGuestlist = null;
        this.newListAvailableElements = [];
        this.newListBlockedElements = [];
        this.newSeatplanElements = {};

        this._loadNewList().then(() => {
            this.newListDataLoading = true;
            this._loadNewListAvailableElements().then(() => {
                this._updateBookingInformation().then(() => {
                    this.newListDataLoading = false;
                    this._setBasicNewElements();
                });
            });
        });
    }

    _loadNewList() {
        return this.api.get(`guestlists/${this.newListId}?include=blockedSeatplanElements,seatplan`).then((response) => {
            this.newGuestlist = response.data.data;
            this.newListBlockedElements = [];

            _.each(this.newGuestlist.blockedSeatplanElements.data, (val) => {
                this.newListBlockedElements.push(val.id);
            });
        }, () => {
            this.growl.error('Error while loading new list', {title: 'Error'});
        });
    }

    _loadNewListAvailableElements() {
        return this.api.get(`guestlists/${this.newListId}/seatplan/available-elements`).then((response) => {
            this.newListAvailableElements = response.data.data;
        }, () => {
            this.growl.error('Error while loading available elements', {title: 'Error'});
        });
    }

    _setBasicNewElements() {
        _.each(this.currentSeatplanElements, (rse, rseId) => {
            this.newSeatplanElements[rseId] = null;

            const availableElements = this.filter('filter')(this.newListAvailableElements, {
                id: rse.seatplan_element_id
            });

            if (availableElements.length > 0) {
                const elementToUse = availableElements[0];
                this.newSeatplanElements[rseId] = {
                    id: elementToUse.id,
                    title: elementToUse.title,
                    group_id: elementToUse.seatplan_group_id
                };
            }
        })
    }

    submitMove() {
        this.api.put(`rsvps/${this.rsvp.id}/move-to-other-list`, this._prepareDataForApi()).then(() => {
            this.injector.get('$state').go('app.guestlists.rsvps.seats', {
                gid: this.newGuestlist.id,
                rsvpId: this.rsvp.id
            });
            this.growl.success('The reservation was moved successfully', {title: 'Success'});
            this.closeModal({});
        }, () => {
            this.growl.error('Error while saving', {title: 'Error'});
        })
    }

    _prepareDataForApi() {
        const out = {
            guestlist_id: this.newGuestlist.id,
            seatplan_elements: {}
        };

        _.each(this.currentSeatplanElements, (rse) => {
            out.seatplan_elements[rse.id] = {
                element_id: this.newSeatplanElements[rse.id].id
            }
        });

        return out;
    }

    validateCurrentData() {
        let dataValid = !!this.currentGuestlist && Object.keys(this.newSeatplanElements).length === Object.keys(this.currentSeatplanElements).length;

        _.each(this.newSeatplanElements, (newElement) => {
            if (!newElement) {
                dataValid = false;
            }
        });
        return dataValid;
    }

    changeElement(rse) {
        const elementsToPreselect = [];
        let groupToShowUpFirst = rse.element.group_id;

        if (this.newSeatplanElements[rse.id]) {
            elementsToPreselect.push(this.newSeatplanElements[rse.id].id);
            groupToShowUpFirst = this.newSeatplanElements[rse.id].group_id;
        }

        this._startElementSelectModal(true, elementsToPreselect, groupToShowUpFirst).then((selectedInformation) => {
            const selectedElements = selectedInformation.elements;
            if (selectedElements.length > 0) {
                const newElement = selectedElements[0];

                this.newSeatplanElements[rse.id] = {
                    id: newElement.id,
                    title: newElement.title,
                    group_id: selectedInformation.group
                };
            }
        }, () => {

        });
    }

    _startElementSelectModal(singleSelect, selectedElements, preSelectedGroup) {
        let selectedElementIds = _.cloneDeep(selectedElements);

        return this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: addElementModalTemplate,
            size: 'xlg',
            controller: 'AddElementModalController',
            resolve: {
                showGroupSelection: () => {
                    return true;
                },
                seatplan: () => {
                    return this.api.get(`seatplans/${this.newGuestlist.seatplan_id}?include=groups`).then((response) => {
                        return response.data.data;
                    });
                },
                currentGroup: () => {
                    return preSelectedGroup ? preSelectedGroup : null;
                },
                hiddenElements: () => {
                    return this.prepareBlockedElements(selectedElementIds);
                },
                bookingInformation: () => {
                    let bookingInformationForSeatplan = _.cloneDeep(this.bookingInformation);
                    _.each(selectedElementIds, (id) => {
                        if (bookingInformationForSeatplan[id]) {
                            delete bookingInformationForSeatplan[id];
                        }
                    });

                    _.each(this.newSeatplanElements, (seatplanElement, rseId) => {
                        if (seatplanElement && selectedElementIds.indexOf(seatplanElement.id) === -1) {
                            if(!bookingInformationForSeatplan[seatplanElement.id]) {
                                bookingInformationForSeatplan[seatplanElement.id]  = []
                            }

                            bookingInformationForSeatplan[seatplanElement.id].push({
                                custom_label: 'Current selection',
                                id: rseId,
                                element: seatplanElement,
                                contact: this.contact,
                                rsvp: this.rsvp
                            });
                        }
                    });

                    return bookingInformationForSeatplan;
                },
                requiredPax: () => {
                    return this.rsvp.pax_planned;
                },
                isSingleSelect: () => {
                    return !!singleSelect;
                },
                currentSelectedElementIds: () => {
                    return selectedElementIds;
                },
                allowElementMultiSelection: () => {
                    return this.allowElementMultiSelection
                }
            },
            controllerAs: 'vm'
        }).result;
    }

    _updateBookingInformation() {
        const rseFastPipe = this.injector.get('RsvpSeatplansElements').reset({
            persist: false,
            listview: 'SeatplanRses'
        });
        rseFastPipe.commit('setPrefix', this.newGuestlist.id);
        return rseFastPipe.dispatch('getDefinitions').then(() => {
            const fieldNamesToGet = [
                    'id',
                    'custom_label',
                    'element.id',
                    'element.title',
                    'rsvp.id',
                    'rsvp.booking_number',
                    'rsvp.blocked',
                    'rsvp.status',
                    'rsvp.comment',
                    'rsvp.custom_label',
                    'rsvp.area_start_time',
                    'rsvp.area_end_time',
                    'rsvp.pax_planned',
                    'rsvp.seatplan_element_pax',
                    'rsvp.seatplan_element_count',
                    'rsvp.checked_in_sign',
                    'rsvp.direct_booking_sign',
                    'rsvp.invited_at',
                    'rsvp.migrate_to_new_year',
                    'rsvp.deleted_at',
                    'contact.id',
                    'contact.customer_number',
                    'contact.full_name',
                    'contact.company_name',
                    'contact.first_name',
                    'contact.last_name',
                    'contact.cnr_full_name_co'
                ],
                columns = [];

            for (let i = 0; i < rseFastPipe.state.columns.length; i++) {
                const curCol = rseFastPipe.state.columns[i];
                if (fieldNamesToGet.indexOf(curCol.key) > -1) {
                    curCol.visible = true;
                    columns.push(curCol);
                }
            }
            rseFastPipe.commit('setColumns', columns);
            rseFastPipe.commit('setFilter', {
                key: "rsvp.deleted_at",
                value: null
            });
            rseFastPipe.commit('setVisible', _.filter(columns, 'visible').map(col => col.key));
            rseFastPipe.commit('setPagination', {perPage: 50000});
            return rseFastPipe.dispatch('getData').then(() => {
                const newBookingInformation = {};

                _.each(rseFastPipe.state.data, (bookedElement) => {
                    if(!newBookingInformation[bookedElement.element.id]) {
                        newBookingInformation[bookedElement.element.id] = [];
                    }

                    newBookingInformation[bookedElement.element.id].push(bookedElement)
                });

                this.bookingInformation = newBookingInformation;
            }, () => {
                this.growl.error('Error while getting booking information', {title: 'Error'});
            });
        }, () => {
            this.growl.error('Error while getting booking information', {title: 'Error'});
        });
    }

    prepareBlockedElements(selectedElementIds) {
        let out
        if(this.allowElementMultiSelection) {
            out = []
        } else {
            out = _.map(this.bookingInformation, (obj, id) => {
                return parseInt(id);
            });

            _.each(this.blockedElements, (v) => {
                out.push(v);
            });
        }

        _.each(this.newListBlockedElements, (v) => {
            out.push(v);
        });

        return _.filter(out, (value) => (selectedElementIds.indexOf(value) === -1));
    }
}

MoveToOtherListMainController.$inject = [
    '$injector',
    'rsvp',
    '$scope',
    '$uibModalInstance'
];

/**
 * @ngdoc object
 * @name guestlists.controller:MoveToOtherListMainController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .controller('MoveToOtherListMainController', MoveToOtherListMainController);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/guestlists/seats/move-to-other-list/main-controller.js